// extracted by mini-css-extract-plugin
export default {"textTitle":"refer-friend-screen_textTitle__Qxlft","inputArea":"refer-friend-screen_inputArea__BZV1B","infoMessage":"refer-friend-screen_infoMessage__ST13s"};